<template>
  <div class="text-left">
    <v-pagination v-model="selectPage" :length="pageCount" :total-visible="11" @input="getNumber"></v-pagination>
  </div>
</template>

<script>
export default {
  name: 'ArchiveDatatablePagination',
  props: {
    'pageCount': {
      type: Number
    },
    'page': {
      type: Number
    }
  },
  data () {
    return {
      selectPage: this.page
    }
  },
  methods: {
    getNumber () {
      this.$emit('changePage', this.selectPage)
    }
  }
}
</script>

<style>
.theme--light.v-pagination .v-pagination__item--active{
  background: #3379b7 !important;
}
</style>
